import React from 'react';
import HeroSection from './components/HeroSection';
import LogoCarousel from './components/LogoCarousel';
import FeatureSection from './components/FeatureSection';
import DigitalGaitSection from './components/DigitalGaitSection';
import WhyIWalkSection from './components/WhyIWalkSection';
// import TestimonialsSection from './components/TestimonialsSection';
import HelpSection from './components/HelpSection';
import NewsletterSection from './components/NewsletterSection';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './index.css';

function App() {
    return (
        <div>
            <Navbar />
            <HeroSection />
            <LogoCarousel />
            <FeatureSection />
            <DigitalGaitSection />
            <WhyIWalkSection />
            
            {/* Hiding Testimonials Section for now */}
            {/* <TestimonialsSection /> */}
            
            <HelpSection />
            
            {/* The Green Newsletter Signup Card */}
            <NewsletterSection />
            
            {/* The Dark Footer */}
            <Footer />
        </div>
    );
}

export default App;
